import React from 'react';
import {
  BrowserRouter as Router,
  Route, Redirect, Switch
} from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import {isAllowed} from "./helpers/authenticator";

import Main from './components/landing-page/Main';
import TrackingPage from './pages/TrackingPage';
import Account from "./pages/account/AccountPage";
import './App.css';
import Dashboard from "./Dashboard";
import CheckoutPage from "./pages/CheckoutPage";
import APIDocsPage from "./pages/APIDocsPage";
import Request from "./components/forms/Request";

const protectedRoute = (isAuthenticated) => {
  return (
    <Switch>
      <Route exact path="/home" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "home"}}/> : <Redirect to="/signin"/>
      }}/>
      <Route exact path="/requests/:id" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "requests"}}/> : <Redirect to="/signin"/>
      }}/>
      <Route exact path="/deliveries/history" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "deliveries"}}/> : <Redirect to="/signin"/>
      }}/>
      <Route exact path="/account" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "account"}}/> : <Redirect to="/signin"/>
      }}/>
      <Route exact path="/deliveries/:id" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "track"}}/> : <Redirect to="/signin"/>
      }}/>
      <Route exact path="/payment/receipt" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "payment"}}/> : <Account route={{id: "signin"}}/>
      }}/>
      <Route exact path="/rider/:id" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "rider"}}/> : <Redirect to="/signin"/>
      }}/>
      <Route exact path="/add/rider" render={() => {
        return isAuthenticated ? <Dashboard route={{id: "add-rider"}}/> : <Redirect to="/signin"/>
      }}/>
    </Switch>
  )
};

const redirectRoutes = (isAuthenticated) => {
  return (
    <Switch>
      <Route exact path="/signin" render={() => {
        return isAuthenticated ? <Redirect to="/home"/> : <Account route={{id: "signin"}}/>
      }}/>
      <Route exact path="/signup" render={() => {
        return isAuthenticated ? <Redirect to="/home"/> : <Account route={{id: "signup"}}/>
      }}/>
    </Switch>
  )
};


const App = () => {
  return (
    <Router>
      <Switch>
        <>
          <Route exact path="/" render={() => <Main/>}/>
          {redirectRoutes(isAllowed())}
          <Route exact path="/track/:id" render={() => <TrackingPage/>}/>
          <Route exact path="/checkout/:id" render={() => <CheckoutPage/>}/>
          <Route exact path="/docs" render={() => <APIDocsPage/>}/>
          <Route exact path="/request" render={() => <Request/>}/>
          {protectedRoute(isAllowed())}
        </>
      </Switch>
    </Router>
  );
};

export default App;

